import { IconProps } from "./IconProps";

const ArrowDownLeftIcon: React.FC<IconProps> = ({
  width = 12,
  height = 12,
  color = "#0F5051",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7071 1.70711C12.0976 1.31658 12.0976 0.683418 11.7071 0.292893C11.3166 -0.0976311 10.6834 -0.0976311 10.2929 0.292893L11.7071 1.70711ZM-3.39982e-07 11C-7.61451e-07 11.5523 0.447714 12 1 12L10 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10L2 10L2 2C2 1.44772 1.55228 1 0.999999 1C0.447715 1 -5.50717e-07 1.44772 -2.13542e-07 2L-3.39982e-07 11ZM11 1L10.2929 0.292893L0.292893 10.2929L0.999999 11L1.70711 11.7071L11.7071 1.70711L11 1Z"
      fill={color}
    />
  </svg>
);

export default ArrowDownLeftIcon;
